export default __webpack_public_path__ + "static/media/flutterwave.6e97705a.png";